import { forwardRef } from "react";
import { TextBox } from "@etframework/ui.components";
import { useTranslation } from "react-i18next";

export const TaskDescriptionTextBox = forwardRef(
  ({ initialValue, id, labelText, ...rest }, ref) => {
    const { t } = useTranslation(["CreateTaskModal"]);

    return (
      <TextBox
        ref={ref}
        id={id}
        name="Description"
        type="text"
        multiline
        labelText={labelText}
        errorMessage={t("ErrorMsg")}
        htmlAttributes={{ rows: "5" }}
        value={initialValue}
        {...rest}
      />
    );
  }
);
